import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../Context/GlobalState";
import {
  FaTachometerAlt,
  FaUserTie,
  FaMoneyBillWave,
  FaUtensils,
} from "react-icons/fa";
import { Pie, Bar, Line } from "react-chartjs-2";
import { Modal, Button, Form } from "react-bootstrap";
import { AddEmployeeModal, AddVenueModal, GeneratePayrollModal } from "./Modal";
import { Employeetable, PayrollTable, ShopTable } from "./Table";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { billpunchbasicauth } from "../../utils/Credentials";

const sideNavItems = [
  { name: "Dashboard", key: "dashboard", icon: <FaTachometerAlt /> },
  { name: "Restaurant", key: "restaurant", icon: <FaUtensils /> },
  { name: "Employee", key: "employee", icon: <FaUserTie /> },
  { name: "Payroll", key: "payroll", icon: <FaMoneyBillWave /> },
];

const Contract = () => {
  const [activeTab, setActiveTab] = useState("dashboard");
  const [hoveredKey, setHoveredKey] = useState(null);

  const renderTabContent = () => {
    switch (activeTab) {
      case "dashboard":
        return <DashboardTab />;
      case "restaurant":
        return <RestaurantTab />;
      case "employee":
        return <EmployeeTab />;
      case "payroll":
        return <PayrollTab />;
      default:
        return <DashboardTab />;
    }
  };

  return (
    <div className="d-flex">
      <div
        style={{
          width: "70px",
          minHeight: "100vh",
          backgroundColor: "#212529",
          color: "white",
        }}
        className="p-2 text-center"
      >
        <ul className="list-unstyled mt-4">
          {sideNavItems.map((item) => {
            const isActive = activeTab === item.key;
            const isHovered = hoveredKey === item.key;

            return (
              <li
                key={item.key}
                onClick={() => setActiveTab(item.key)}
                onMouseEnter={() => setHoveredKey(item.key)}
                onMouseLeave={() => setHoveredKey(null)}
                style={{
                  cursor: "pointer",
                  fontSize: "1.4rem",
                  marginBottom: "1rem",
                  padding: "6px",
                  borderRadius: "8px",
                  backgroundColor: isActive
                    ? "#f8f9fa"
                    : isHovered
                    ? "#495057"
                    : "transparent",
                  color: isActive ? "#212529" : "#ffffff",
                  position: "relative",
                  transition: "all 0.3s ease",
                }}
              >
                {item.icon}
                {isHovered && (
                  <span
                    style={{
                      position: "absolute",
                      left: "90px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      backgroundColor: "#343a40",
                      color: "#fff",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      whiteSpace: "nowrap",
                      fontSize: "0.8rem",
                      zIndex: 1,
                    }}
                  >
                    {item.name}
                  </span>
                )}
              </li>
            );
          })}
        </ul>
      </div>

      <div className="flex-grow-1 p-4 mt-3">{renderTabContent()}</div>
    </div>
  );
};
const RestaurantTab = () => {
  const [showModal, setShowModal] = useState(false);

  const handleSaveVenue = (data) => {
    console.log("Venue data saved:", data);
  };
  const [shopData, setShopData] = useState([]);
  const { user } = useContext(GlobalContext);
  const { username, password } = billpunchbasicauth;

  const fetchShopData = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetRestaurantDetails`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ firmid: user.firm_id }),
        }
      );
      const data = await response.json();

      if (data.status === "0" && Array.isArray(data.data)) {
        setShopData(data.data);
      } else {
        console.error("Failed to fetch shop data", data);
      }
    } catch (error) {
      console.error("Error fetching shop data:", error);
    }
  };

  useEffect(() => {
    fetchShopData();
  }, []);
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <h5 style={{ margin: 0 }}>Restaurant Management</h5>
        <Button variant="success" size="sm" onClick={() => setShowModal(true)}>
          Add Venue
        </Button>
      </div>
      <ShopTable shopData={shopData} />
      <AddVenueModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        onSave={handleSaveVenue}
        fetchShopData={fetchShopData}
      />
    </div>
  );
};

const DashboardTab = () => {
  const pieData = {
    labels: ["Active", "Inactive", "On Leave"],
    datasets: [
      {
        label: "Employee Status",
        data: [85, 25, 10],
        backgroundColor: ["#28a745", "#dc3545", "#ffc107"],
        borderWidth: 1,
      },
    ],
  };

  const barData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May"],
    datasets: [
      {
        label: "Monthly Payroll (₹ in K)",
        data: [45, 50, 48, 60, 55],
        backgroundColor: "#007bff",
        borderRadius: 5,
      },
    ],
  };

  const lineData = {
    labels: ["Week 1", "Week 2", "Week 3", "Week 4"],
    datasets: [
      {
        label: "New Contracts",
        data: [12, 19, 7, 15],
        fill: false,
        borderColor: "#17a2b8",
        backgroundColor: "#17a2b8",
        tension: 0.3,
        pointRadius: 5,
        pointHoverRadius: 7,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { position: "bottom" },
      tooltip: { enabled: true },
    },
  };

  return (
    <div>
      <h4 className="mb-4">Dashboard Overview</h4>

      {/* Stats Cards */}
      <div className="row">
        <div className="col-md-4 mb-3">
          <div className="card text-white bg-primary">
            <div className="card-body">
              <h5 className="card-title">Total Employees</h5>
              <p className="card-text display-6">120</p>
            </div>
          </div>
        </div>

        <div className="col-md-4 mb-3">
          <div className="card text-white bg-success">
            <div className="card-body">
              <h5 className="card-title">Active Contracts</h5>
              <p className="card-text display-6">95</p>
            </div>
          </div>
        </div>

        <div className="col-md-4 mb-3">
          <div className="card text-white bg-warning">
            <div className="card-body">
              <h5 className="card-title">Pending Payrolls</h5>
              <p className="card-text display-6">12</p>
            </div>
          </div>
        </div>
      </div>

      {/* Charts */}
      <div className="row mt-4">
        {/* Pie Chart */}
        <div className="col-md-4 mb-4">
          <div className="card p-3 shadow-sm">
            <h5 className="text-center">Employee Status Overview</h5>
            <Pie data={pieData} options={chartOptions} />
          </div>
        </div>

        {/* Bar Chart */}
        <div className="col-md-4 mb-4">
          <div className="card p-3 shadow-sm">
            <h5 className="text-center">Payroll Trend (Last 5 Months)</h5>
            <Bar data={barData} options={chartOptions} />
          </div>
        </div>

        {/* Line Chart */}
        <div className="col-md-4 mb-4">
          <div className="card p-3 shadow-sm">
            <h5 className="text-center">New Contracts (Weekly)</h5>
            <Line data={lineData} options={chartOptions} />
          </div>
        </div>
      </div>
    </div>
  );
};

const EmployeeTab = () => {
  const [showEmployeeModal, setShowEmployeeModal] = useState(false);
  const handleSaveEmployee = (data) => {
    console.log("Employee data saved:", data);
  };
  const [employeedata, setemployeedata] = useState([]);
  const { user } = useContext(GlobalContext);
  const { username, password } = billpunchbasicauth;

  const fetchemployeedata = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetContractEmployees`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ firmid: user.firm_id }),
        }
      );
      const data = await response.json();

      if (data.status === "0" && Array.isArray(data.data)) {
        setemployeedata(data.data);
      } else {
        console.error("Failed to fetch employee data", data);
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };

  useEffect(() => {
    fetchemployeedata();
  }, []);
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <h5 style={{ margin: 0 }}>Employee Management</h5>
        <Button
          variant="success"
          size="sm"
          onClick={() => setShowEmployeeModal(true)}
        >
          Add Employee
        </Button>
      </div>
      <Employeetable employeedata={employeedata} />
      <AddEmployeeModal
        show={showEmployeeModal}
        handleClose={() => setShowEmployeeModal(false)}
        onSave={handleSaveEmployee}
        fetchemployeedata={fetchemployeedata}
      />
    </div>
  );
};
const PayrollTab = () => {
  const [showModal, setShowModal] = useState(false);
  const [payrolldata, setpayrolldata] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const { user } = useContext(GlobalContext);
  const { username, password } = billpunchbasicauth;

  const fetchpayrolldata = async (month) => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetRestaurantTransaction`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            month: month.toString(),
            firmid: user.firm_id,
          }),
        }
      );
      const data = await response.json();

      if (data.status === "0" && Array.isArray(data.data)) {
        setpayrolldata(data.data);
      } else {
        console.error("Failed to fetch payroll data", data);
        setpayrolldata([]); // clear if error
      }
    } catch (error) {
      console.error("Error fetching payroll data:", error);
      setpayrolldata([]); // clear if error
    }
  };

  useEffect(() => {
    fetchpayrolldata(selectedMonth);
  }, [selectedMonth]);

  const handleMonthChange = (e) => {
    const month = parseInt(e.target.value);
    setpayrolldata([]); // clear table immediately
    setSelectedMonth(month); // trigger fetch for new month
  };

  const monthOptions = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <h5 style={{ margin: 0 }}>Payroll Details</h5>

        <div style={{ display: "flex", alignItems: "center" }}>
          <Form.Select
            style={{ width: "150px", marginRight: "0.75rem" }}
            value={selectedMonth}
            onChange={handleMonthChange} // Use new handler here
          >
            {monthOptions.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </Form.Select>

          <Button
            size="sm"
            variant="success"
            onClick={() => setShowModal(true)}
          >
            Generate Payroll
          </Button>
        </div>
      </div>

      <PayrollTable data={payrolldata} fetchpayrolldata={fetchpayrolldata} />

      <GeneratePayrollModal
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </div>
  );
};

export default Contract;
